import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  globalAllStatus: null
}

const globalDDSSlices = createSlice({
  name: "globalDDS",
  initialState,
  reducers: {
    setGlobalAllstatus: (state, action) => {
      state.globalAllStatus = action.payload
    }
  }
});

export const { setGlobalAllstatus } = globalDDSSlices.actions;

export default globalDDSSlices.reducer;